<app-layout-row margin="">
  <app-layout-column [width]="11">
    <app-layout-row margin="">
      <app-layout-column [width]="11">
        <app-layout-row margin="">

          <app-layout-column [width]="3">
            <app-singleselectbox name="typeKey" caption="Type" [ngModel]="condition().TypeKey" [grouped]="false"
              [dataSource]="conditionTypes()" valueExpr="key" displayExpr="name" required (valueChange)="onConditionTypeChange($event)">
            </app-singleselectbox>
          </app-layout-column>

          @if (this.hasSubTypes()) {
            <app-layout-column [width]="3">
              <app-singleselectbox name="subTypeKey" caption="Sub Type" [ngModel]="condition().SubTypeKey"
                [dataSource]="this.subConditionTypes()" valueExpr="key" displayExpr="name" required (valueChange)="onSubConditionTypeChange($event)" [disabled]="!subTypeEnabled()">
              </app-singleselectbox>
            </app-layout-column>
          }

          <app-layout-column [width]="3">
            <app-singleselectbox name="operatorKey" caption="Conditional" [ngModel]="condition().ComparerKey"
              [dataSource]="this.comparers()" valueExpr="key" displayExpr="name" required (valueChange)="onComparerChange($event)" [disabled]="!comparerEnabled()">
            </app-singleselectbox>
          </app-layout-column>

          <app-layout-column [width]="3">
            @if (this.isPartnerLookup()) {
              <div class="partner-select-layout">
                <div class="flex"><label class="partner-label" title="Value" for="value">Value</label><span class="partner-required"> *</span></div>
                <ep-partner-selector id="partnerValue"
                  [isReadOnly]="false"
                  name="value" required [ngModel]="condition().Values[0].value" (selectedPartnerChange)="onValueChange(0, $event)" [disabled]="!valueEnabled()">
                </ep-partner-selector>
                <div></div>
              </div>
            }
            @else {
            @if (this.values()?.length > 0) {
              <app-singleselectbox name="value" caption="Value" [ngModel]="condition().Values[0].value"
                [dataSource]="this.values()" valueExpr="key" displayExpr="name" required (ngModelChange)="onValueChange(0, $event)" [disabled]="!valueEnabled()">
              </app-singleselectbox>
            }
            @else {
            <app-textbox [ngModel]="condition().Values[0].value" name="value" caption="Value" required (ngModelChange)="onValueChange(0, $event)" [disabled]="!valueEnabled()"></app-textbox>
          }
        }
      </app-layout-column>

      @if (!hasSubTypes()) {
        <app-layout-column [width]="3">
          <div class="orButton">
            @if (condition().Values.length==1) {
              <app-link iconClass="dx-icon-add" (onClick)="addValue($event)" [disabled]="!orEnabled()" title="Only possible if the Conditonal is either 'Equals' or 'Contains'">OR</app-link>
            }
          </div>
        </app-layout-column>
      }

    </app-layout-row>
  </app-layout-column>
  <app-layout-column [width]="1">

    @if (condition().Values.length==1 && this.hasSubTypes()) {
      <div class="orButton">
        <app-link iconClass="dx-icon-add" (onClick)="addValue($event)" [disabled]="!orEnabled()" title="Only possible if the Conditonal is either 'Equals' or 'Contains'">OR</app-link>
      </div>
    }

  </app-layout-column>
</app-layout-row>
</app-layout-column>
<app-layout-column [width]="1">
  <div class="conditionButtons">
    <app-link iconClass="dx-icon-trash" (onClick)="deleteCondition()">Remove</app-link>
  </div>
</app-layout-column>
</app-layout-row>

<ng-container ngModelGroup="additionalValues">
  @for (value of $safeNavigationMigration(condition()?.Values) | slice:1; track value; let idx = $index) {
    <fieldset [ngModelGroup]="value.id" #form="ngModelGroup">
      <app-layout-row margin="">
        <app-layout-column [width]="11">
          <app-layout-row margin="">
            <app-layout-column [width]="11">
              <app-layout-row margin="">
                <app-layout-column [width]="3" [offset]="this.hasSubTypes() ? 6 : 3">
                </app-layout-column>
                <app-layout-column [width]="3">
                  @if (this.isPartnerLookup()) {
                    <div class="partner-select-layout">
                      <div class="flex"><label class="partner-label" title="Value" for="value">Value</label><span class="partner-required"> *</span></div>
                      <ep-partner-selector id="partnerValue"
                        [isReadOnly]="false"
                        name="value" required [ngModel]="condition().Values[idx+1].value" (selectedPartnerChange)="onValueChange(idx+1, $event)" [disabled]="!valueEnabled()">
                      </ep-partner-selector>
                      <div></div>
                    </div>
                  }
                  @else {
                  @if (this.values()?.length > 0) {
                    <app-singleselectbox name="value" caption="Or" [ngModel]="condition().Values[idx+1].value"
                      [dataSource]="this.values()" valueExpr="key" displayExpr="name" required (ngModelChange)="onValueChange(idx+1, $event)" [disabled]="!valueEnabled()">
                    </app-singleselectbox>
                  }
                  @else {
                  <app-textbox [ngModel]="condition().Values[idx+1].value" name="value" caption="Or" required (ngModelChange)="onValueChange(idx+1, $event)" [disabled]="!valueEnabled()" title="Only possible if the Conditonal is either 'Equals' or 'Contains'"></app-textbox>
                }
              }
            </app-layout-column>
            @if (!this.hasSubTypes()) {
              <app-layout-column [width]="3">
                <div class="orButton">
                  @if (condition().Values.length==idx+2) {
                    <app-link iconClass="dx-icon-add" (onClick)="addValue($event)" [disabled]="!orEnabled()" title="Only possible if the Conditonal is either 'Equals' or 'Contains'">OR</app-link>
                  }
                </div>
              </app-layout-column>
            }
          </app-layout-row>
        </app-layout-column>
        <app-layout-column [width]="1">
          <div class="orButton">
            @if (condition().Values.length==idx+2 && this.hasSubTypes()) {
              <app-link iconClass="dx-icon-add" (onClick)="addValue($event)" [disabled]="!orEnabled()">OR</app-link>
            }
          </div>
        </app-layout-column>
      </app-layout-row>
    </app-layout-column>
    <app-layout-column [width]="1">
      <div class="conditionButtons">
        <app-link iconClass="dx-icon-trash" (onClick)="deleteValue(idx)">Remove</app-link>
      </div>
    </app-layout-column>
  </app-layout-row>
</fieldset>
}
</ng-container>